import { Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { DepositService } from '../../../../service/deposit.service';
import { DepositRedirectService } from '../../../../service/depositRedirect.service';
import { ResizeService } from '../../../../service/resize.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-redirect-message',
    templateUrl: 'redirect-message.component.html',
    standalone: true,
    imports: [MessageComponent, TranslateModule],
})
export class RedirectMessageComponent {
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    constructor(
        public depositRedirectService: DepositRedirectService,
        private depositService: DepositService,
        private resizeService: ResizeService,
    ) {
        this.resizeService.resizeCashier();
    }

    redirectToThirdParty() {
        this.depositRedirectService.redirectToThirdParty(this.depositService.handleResponse);
        this.resizeService.resizeCashier();
    }
}
